import { render } from "./MarkItem.vue?vue&type=template&id=067f404a&scoped=true"
import script from "./MarkItem.vue?vue&type=script&lang=js"
export * from "./MarkItem.vue?vue&type=script&lang=js"

import "./MarkItem.vue?vue&type=style&index=0&id=067f404a&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067f404a"]])

export default __exports__